import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function SystemModulesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  requirementId,
  showRequirement,
  requirementInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(requirementId)) return;
    showRequirement(requirementId);
  }, [requirementId]);

  const renderStatus = status => {
    if (status) {
      return <div className="btn btn-sm btn-success">ACTIVE</div>;
    }
    return <div className="btn btn-sm btn-danger">INACTIVE</div>;
  };

  const app_status = _.get(requirementInfo, 'attributes.how_tos_sub_menu');

  const createMarkup = (data) => {
    return {__html: data};
  }

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(requirementInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">
                    {_.get(requirementInfo, 'attributes.title_en') || '--'}
                  </h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(requirementInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(requirementInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col">
                    <Tabs>
                      <TabList>
                        <Tab>English</Tab>
                        <Tab>Filipino</Tab>
                      </TabList>
                      <TabPanel>
                        <div>
                          <table className="table table-striped table-borderless">
                            <tbody>
                              <tr>
                                <th className="table-title">
                                  Title Name (English):
                                </th>
                                <td>
                                  {_.get(
                                    requirementInfo,
                                    'attributes.title_en'
                                  ) || '--'}
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">Status:</th>
                                <td>
                                  {renderStatus(
                                    _.get(
                                      requirementInfo,
                                      'attributes.is_active'
                                    )
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">Sequence:</th>
                                <td>
                                  {_.get(
                                    requirementInfo,
                                    'attributes.sequence'
                                  ) || '--'}
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">
                                  Description (English):
                                </th>
                                <td>
                                  <div 
                                    // eslint-disable-next-line
                                    dangerouslySetInnerHTML={createMarkup(_.get(requirementInfo,'attributes.description_en') || '--')} 
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </TabPanel>
                      <TabPanel>
                        <div>
                          <table className="table table-striped table-borderless">
                            <tbody>
                              <tr>
                                <th className="table-title">
                                  Title Name (Filipino):
                                </th>
                                <td>
                                  {_.get(
                                    requirementInfo,
                                    'attributes.title_tl'
                                  ) || '--'}
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">Status:</th>
                                <td>
                                  {renderStatus(
                                    _.get(
                                      requirementInfo,
                                      'attributes.is_active'
                                    )
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">Sequence:</th>
                                <td>
                                  <div 
                                    // eslint-disable-next-line
                                    dangerouslySetInnerHTML={createMarkup(_.get(requirementInfo,'attributes.description_tl') || '--')} 
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th className="table-title">
                                  Description (Filipino):
                                </th>
                                <td>
                                  {_.get(
                                    requirementInfo,
                                    'attributes.description_tl'
                                  ) || '--'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </TabPanel>
                    </Tabs>
                  </div>

                  <div className="row d-flex justify-content-center w-100 border-top">
                    <div className="font-weight-bold col-12 mt-2 text-center">
                      List Sub Menus
                    </div>
                    <div className="col-12">
                      <table className="table table-striped table-borderless">
                        <thead>
                          <tr>
                            <th>Description</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {app_status && app_status.length ? (
                            _.get(
                              requirementInfo,
                              'attributes.how_tos_sub_menu'
                            ).map(e => (
                              <tr key={e.id}>
                                <td>{e.title_en}</td>
                                <td>
                                  <div 
                                    // eslint-disable-next-line
                                    dangerouslySetInnerHTML={createMarkup(e.description_en)} 
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data</td>
                              <td />
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

SystemModulesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  showRequirement: PropTypes.instanceOf(Function).isRequired,
  requirementInfo: PropTypes.instanceOf(Object).isRequired,
  requirementId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  requirementInfo: _.get(api, `${c.GET_SINGLE_REQUIREMENT}.item`) || {},
  requirementId: _.get(match, 'params.requirementId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(SystemModulesContent);
